import { composeThemeFromProps, Compose } from '@css-modules-theme/react';
import React from 'react';
import { Search, Loader } from 'react-feather';
import { useUncontrolled } from '../../hooks/useUncontrolled.js';
import defaultStyles from './styles/InputSearch.module.scss.js';
import { jsx } from 'react/jsx-runtime';
import { Input } from '../input/Input.js';
import { omit } from '../../utils/omit.js';
import { Button } from '../button/Button.js';

const ID_SUFFIX = '_input_search';
const InputSearch = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    theme,
    style,
    placeholder,
    disabled,
    searchButton,
    loading,
    value,
    defaultValue,
    onChange,
    idSuffix = ID_SUFFIX,
    ...rest
  } = props;
  const styles = composeThemeFromProps(defaultStyles, {
    theme
  }, {
    compose: Compose.Merge
  });

  // Should show label
  const [_value, handleChange] = useUncontrolled({
    value,
    defaultValue,
    fallbackValue: '',
    onChange
  });
  const onSearch = e => {
    !disabled && props.onSearch && props.onSearch(_value);
    props.onPressEnter && props.onPressEnter(e);
  };
  return /*#__PURE__*/jsx(Input, {
    ...omit(rest, ['onSearch']),
    disabled: disabled,
    theme: {
      with_addons: styles.group_wrapper,
      input: styles.input_search,
      ...theme
    },
    style: style,
    ref: ref,
    placeholder: placeholder,
    addAfter: searchButton ? /*#__PURE__*/jsx(Button, {
      disabled: disabled,
      size: rest.size,
      flat: true,
      fluid: true,
      theme: {
        root: styles.button
      },
      status: "primary",
      onClick: onSearch,
      loading: loading,
      loadingFixedWidth: true,
      icon: searchButton === true && !loading && /*#__PURE__*/jsx(Search, {}),
      children: searchButton !== true && searchButton
    }) : null,
    suffix: !searchButton && (loading ? /*#__PURE__*/jsx(Loader, {}) : /*#__PURE__*/jsx(Search, {
      onClick: onSearch
    })),
    onChange: handleChange,
    defaultValue: defaultValue,
    onPressEnter: onSearch,
    idSuffix: idSuffix
  });
});
InputSearch.displayName = 'InputSearch';

export { InputSearch };
